import { Box, Container, Typography } from "@mui/material";
import SwipeableViews from "react-swipeable-views";
import NumberedCirclesButtons from "../../../../components/steps/NumberedCirclesButtons";
import JoinTheWaitlistButton from "../../../../components/buttons/JoinTheWaitlist";

import ProcessSteps from "../../components/ProcessSteps";
import { useState } from "react";
import { makeStyles } from "@mui/styles";
import OneProduct__StoryShoutoutOI from "./components/desktop/OneProduct__StoryShoutoutOI";
import OneProduct__AutomatedFormat from "./components/desktop/OneProduct__TextAndTagging";
import OneProduct__PricingMethod from "./components/desktop/OneProduct__PricingMethod";
import { withWidth } from "@material-ui/core";
import OneProductMarketplaceSteps__desktop from "./components/desktop";
import OneProductMarketplaceSteps__mobile from "./components/mobile";
import { Button } from '@mui/material';
const useStyles = makeStyles((theme) => ({
  textMonarcha: {
    fontFamily: "monarcha,open-sans !important",
    textTransform: "uppercase !important",
    color: "white ",
    fontWeight: "bold !important",
  },
  textOpenSans: {
    fontFamily: "open-sans,san-serif !important",
    textTransform: "normal",
    color: "white",
  },
}));

const OneProductMarketplaceSteps = ({ width, ...props }) => {
  const classes = useStyles();

  const [index, setIndex] = useState(0);

  const handleChangeIndex = (index) => {
    setIndex(index);
  };
  return (
    <Box sx={{ height: "fit-content", marginBottom: 0 }}>
      <div>
        <Typography
          className={classes.textMonarcha}
          variant="h5"
          sx={{
            position: "relative",
            display: "block",
            textAlign: "center",
            color: index === 2 ? "#ffffff44" : "#ffbf12",
            lineHeight: 1.3,
            marginTop: 2,
            marginBottom: 3,
            fontSize: width === "xs" ? "14px" : "",
          }}
        >
          3 Steps to Let Your AI Agent{width === "xs" && <br />} Sell Shoutouts
          on PassionStocks <br />
          <span style={{ color: index === 2 ? "#ffbf12" : "#ffffff44" }}>
            & AUTO-DELIVER THEM ON PassionStocks
          </span>
        </Typography>
        <NumberedCirclesButtons
          variant={width === "xs" ? "small" : ""}
          count={3}
          checkedIndex={index}
          setIndex={setIndex}
        />
      </div>
      <SwipeableViews
        style={{ overflow: "visible !important" }}
        index={index}
        onChangeIndex={handleChangeIndex}
      >
        <div
          style={{
            margin: "30px auto 0",
            maxWidth: "90vw",
            height:
              width === "xs"
              ? ["350px", "430px", "500px"][index]
              : ["470px", "720px", "720px"][index],
            }}
        >
          <div>
            <Typography
              className={classes.textMonarcha}
              variant="h6"
              sx={{
                color: "#ffbf12",
                textAlign: "center",
                marginBottom: 1,
                fontSize: width === "xs" ? "12px" : "",
                minheight: 1,
                display: "block",
                transform: "translateZ(0)",
              }}
            >
              1. Get Your AI Agent by Opening a Creator Account
            </Typography>
            <Typography
              className={classes.textOpenSans}
              variant="body"
              sx={{
                display: "block",
                color: "#ffffff77",
                textAlign: "center",
                fontWeight: "lighter",
                fontSize: width === "xs" ? "9px" : "",
              }}
            >
              If you have at least 1,000 followers/subscribers on one of your social media
              accounts, you can open a Creator Account on PassionStocks
              <br /> and let your AI Agent start selling Shoutouts on your
              Shoutout Wall.
              <br />
              <br />
              <span
                style={{
                  paddingTop: "8px",
                  fontWeight: "bold",
                  lineHeight: "10px !important",
                }}
              >
                Below, you can see how Shoutout listings appear on our AI
                Marketplace
                <br />— Shoutouts are listed, priced, formatted, and delivered
                automatically by your AI Agent.
              </span>
            </Typography>
            <img
              src={"/images/digital-card-details.png"}
              alt="Thank You Mention Digital Card"
              style={{
                display: "block",
                margin: width === "xs" ? "15px auto 0" : "35px auto 0",
                position: "relative",
                width: width === "xs" ? "270px" : "630px",
                zIndex: 6,
              }}
            />{" "}
            <Typography
              className={classes.textMonarcha}
              variant="subtitle1"
              sx={{
                color: "#ffbf12",
                textAlign: "center",
                lineHeight: 1.3,
                marginTop: 5,
                marginBottom: 5,
                fontSize: width === "xs" ? "12px" : "",
              }}
            >
              Buyers can resell your shoutouts{width === "xs" && <br />} if you
              allow them, <br />
              <span style={{ color: "#ffffff66" }}>
                boosting your journey to a {width === "xs" && <br />}$1B
                personal brand valuation.{" "}
                <a
                  style={{ textDecoration: "underline" }}
                  href="https://support.passionstocks.com/articles/134863-can-buyers-resell-my-shoutouts"
                >
                  Learn more
                </a>
              </span>{" "}
            </Typography>
          </div>
        </div>
        <div
          style={{
            margin: "30px auto 0",
            maxWidth: "90vw",
            height:
              width === "xs"
              ? ["350px", "430px", "480px"][index]
              : ["470px", "720px", "720px"][index],
              minheight: 1,
            display: "block",
            transform: "translateZ(0)",
          }}
        >
          <Typography
            className={classes.textMonarcha}
            variant="h6"
            sx={{
              color: "#ffbf12",
              textAlign: "center",
              marginBottom: 1,
              fontSize: width === "xs" ? "12px" : "",
            }}
          >
            2. Buyers buy shoutouts from your AI agent
          </Typography>
          <Typography
            className={classes.textOpenSans}
            variant="body"
            sx={{
              display: "block",
              color: "#ffffff77",
              textAlign: "center",
              fontSize: width === "xs" ? "9px" : "",
            }}
          >
            Buyers can purchase Shoutouts from your AI Agent on the Marketplace,
            see their impact on your personal brand valuation,
            <br />
            and track how they bring you closer to your IPO with each shoutout
            purchase.
            <br />
            <br />
            <span style={{ paddingTop: "8px", fontWeight: "bold" }}>
              Below, you can see how the checkout process looks for buyers.{" "}
            </span>
          </Typography>
          <img
            src={"/images/review-purchase-details-step2.png"}
            alt="Thank You Mention Digital Card"
            style={{
              display: "block",
              margin: width === "xs" ? "15px auto 0" : "25px auto 0",
              paddingLeft: width === "xs" ? "0" : "65px",
              position: "relative",
              width: width === "xs" ? "320px" : "750px",
              zIndex: 6,
            }}
          />{" "}
          <Typography
            className={classes.textMonarcha}
            variant="subtitle1"
            sx={{
              color: "#ffbf12",
              textAlign: "center",
              lineHeight: 1.3,
              marginTop: 5,
              marginBottom: 5,
              fontSize: width === "xs" ? "12px" : "",
            }}
          >
            Buyers can resell your shoutouts{width === "xs" && <br />} if you
            allow them, <br />
            <span style={{ color: "#ffffff66" }}>
              boosting your journey to a{width === "xs" && <br />} $1B personal
              brand valuation.{" "}
              <a
                style={{ textDecoration: "underline" }}
                href="https://support.passionstocks.com/articles/134863-can-buyers-resell-my-shoutouts"
              >
                Learn more
              </a>
            </span>{" "}
          </Typography>
        </div>
        <div
          style={{
            margin: "30px auto 0",
            maxWidth: "90vw",
            height:
              width === "xs"
                ? ["350px", "430px", "480px"][index]
                : ["470px", "720px", "720px"][index],
            minheight: 1,
            display: "block",
            transform: "translateZ(0)",
          }}
          id="safariIssue"
        >
          <Typography
            className={classes.textMonarcha}
            variant="h6"
            sx={{
              color: "#ffbf12",
              textAlign: "center",
              marginBottom: 1,
              fontSize: width === "xs" ? "12px" : "",
            }}
          >
            3. Your AI Agent Delivers the shoutouts on your shoutout wall{" "}
          </Typography>
          <Typography
            className={classes.textOpenSans}
            variant="body"
            sx={{
              display: "block",
              color: "#ffffff77",
              textAlign: "center",
              fontSize: width === "xs" ? "9px" : "",
            }}
          >
            Your AI Agent automatically delivers Shoutouts on your Shoutout
            Wall, organizing them by who impacts{width !== "xs" && <br />}
            your personal brand valuation & IPO Readiness the most.
            <br />
            <br />
            <span style={{ paddingTop: "8px", fontWeight: "bold" }}>
              Below, you can see how buyers appear on the creator’s Shoutout
              Wall.{" "}
            </span>
          </Typography>
          <img
            src={"/images/shoutout-wall-step3.png"}
            alt="Thank You Mention Digital Card"
            style={{
              display: "block",
              margin: width === "xs" ? "15px auto 0" : "35px auto 0",
              paddingLeft: width === "xs" ? "0" : "75px",
              position: "relative",
              width: width === "xs" ? "330px" : "720px",
              zIndex: 6,
            }}
          />{" "}
          <Typography
            className={classes.textMonarcha}
            variant="subtitle1"
            sx={{
              color: "#ffbf12",
              textAlign: "center",
              lineHeight: 1.3,
              marginTop: 5,
              marginBottom: 5,
              fontSize: width === "xs" ? "12px" : "",
            }}
          >
            Buyers can resell your shoutouts {width === "xs" && <br />} if you allow them, <br />
            <span style={{ color: "#ffffff66" }}>
              boosting your journey to a{width === "xs" && <br />} $1B personal
              brand valuation.{" "}
              <a
                style={{ textDecoration: "underline" }}
                href="https://support.passionstocks.com/articles/134863-can-buyers-resell-my-shoutouts"
              >
                Learn more
              </a>
            </span>{" "}
          </Typography>
        </div>
      </SwipeableViews>
      {/* <JoinTheWaitlistButton /> */}
      <Button
            className={classes.textOpenSans}
            sx={{
              textTransform: "none",
              color: "black",
              fontSize: "16px",
              lineHeight: 2.1,
              padding: "5px 65px",
              background: "#ffbf12",
              borderRadius: "50px",
              margin: "20px auto",
              display: "block",
              "&:hover": { background: "#ffbf12" },
            }}
            onClick={() => {
              window.open("https://passionstocks.com");
            }}
          >
            Sign Up / Log In
          </Button>

      <Typography
        className={classes.textMonarcha}
        variant="h5"
        sx={{
          fontSize:
            width === "xl" ? "1.75rem !important" : "1.75rem !important",
          textAlign: "center",
          lineHeight: 1.3,
          color: "#ffbf12",
          marginBottom: { xs: 1, sm: 0 },
          marginTop: 12,
        }}
      >
        Passionstocks {width === "xs" && <br />}One-product
        {width === "xs" && <br />} AI marketplace {width === "xs" && <br />} for
        shoutouts{" "}
      </Typography>
      <Typography
        className={classes.textOpenSans}
        variant="subtitle1"
        sx={{ textAlign: "center", lineHeight: 1.3, color: "#ffffff77" }}
      >
        where product value comes entirely {width === "xs" && <br />}from the
        personal brand
      </Typography>
      <img
        src="/images/avatars-graphs.svg"
        alt="Graph by avatars"
        style={{
          display: "block",
          margin: "10px auto",
          width: width === "xs" ? `70vw` : "25vw",
        }}
      />

      {width === "xs" ? (
        <OneProductMarketplaceSteps__mobile />
      ) : (
        <OneProductMarketplaceSteps__desktop />
      )}
    </Box>
  );
};

export default withWidth()(OneProductMarketplaceSteps);
